// extracted by mini-css-extract-plugin
module.exports =  {"center":"zf6z_X47","heading":"E8vnXN_I","title":"LoK7jDMx","subtitle":"NnItwOCu"};